module.exports = __webpack_public_path__ + "img/f1-panel-list2-1.311d4b85.png";